var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
import { Icon } from "../../icon";
import { StyledSystemStyledNotification, IconWrapper, TextWrapper, StyledTitle, StyledText, } from "./systemnotification.styles";
export const SystemNotification = (_a) => {
    var { title, text = "you have error", notificationType = "error", notificationStyle = "light", symbol = "Error2", width = "fit-content" } = _a, restProps = __rest(_a, ["title", "text", "notificationType", "notificationStyle", "symbol", "width"]);
    const theme = useTheme();
    function getColor() {
        if (notificationStyle === "light") {
            if (notificationType === "error" || notificationType === "warning")
                return theme.colors.error;
            if (notificationType === "success")
                return theme.colors.success;
            if (notificationType === "info")
                return theme.colors.primaryLight;
            if (notificationType === "neutral")
                return theme.colors.grey15;
        }
        return theme.colors.white;
    }
    return (_jsxs(StyledSystemStyledNotification, Object.assign({ notificationType: notificationType, notificationStyle: notificationStyle, symbol: symbol, title: title, text: text }, restProps, { children: [_jsx(IconWrapper, Object.assign({ notificationType: notificationType, notificationStyle: notificationStyle }, { children: _jsx(Icon, { symbol: symbol, width: "1.25rem", color: `${getColor()}` }) })), _jsxs(TextWrapper, Object.assign({ notificationType: notificationType, notificationStyle: notificationStyle, width: width }, { children: [title && notificationStyle !== "compact" ? (_jsx(StyledTitle, Object.assign({ notificationType: notificationType, notificationStyle: notificationStyle }, { children: title }))) : (""), _jsx(StyledText, Object.assign({ notificationType: notificationType, notificationStyle: notificationStyle }, { children: text })), " "] }))] })));
};
